// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/FilterButtonDropDown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./input-clear.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zervantDropSelect {
  width: 300px;
  position: relative;
}
.zervantDropSelect__inputContainer {
  width: inherit;
  height: 40px;
  border-radius: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border: 1px solid #E8E9F0;
}
.zervantDropSelect__inputContainer-active {
  border: 1px solid #01FF94;
}
.zervantDropSelect__inputContainer-highlight {
  border: 1px solid #01FF94;
  -webkit-box-shadow: 1px 1px 12px 0 #F5F6F9;
          box-shadow: 1px 1px 12px 0 #F5F6F9;
}
.zervantDropSelect__inputContainer-error {
  border: 1px solid #D92D20;
}
.zervantDropSelect__inputContainer-disabled {
  pointer-events: none;
}
.zervantDropSelect__inputContainer-emptyState {
  pointer-events: none;
}
.zervantDropSelect__inputContainer-emptyState .zervantDropSelect__input {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding-left: 12px;
  font-size: 12px;
  color: #002E33;
}
.zervantDropSelect__searchIcon {
  -ms-flex-preferred-size: 24px;
      flex-basis: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px;
  background-position-x: 8px;
  background-position-y: 13px;
}
.zervantDropSelect__input {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
.zervantDropSelect__input input {
  height: 100%;
  border: none;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
  font-family: "Aeonik", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 2.29;
  text-align: left;
  padding-left: 8px;
  padding-right: 24px;
  color: #002E33;
}
.zervantDropSelect__input input::-webkit-input-placeholder {
  color: #A7A9B4;
}
.zervantDropSelect__input input::-moz-placeholder {
  color: #A7A9B4;
}
.zervantDropSelect__input input:-ms-input-placeholder {
  color: #A7A9B4;
}
.zervantDropSelect__input input::-ms-input-placeholder {
  color: #A7A9B4;
}
.zervantDropSelect__input input::placeholder {
  color: #A7A9B4;
}
.zervantDropSelect__input input:focus {
  border: none;
}
.zervantDropSelect__dropIcon {
  -ms-flex-preferred-size: 40px;
      flex-basis: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px;
}
.zervantDropSelect__dropIcon:hover {
  cursor: pointer;
}
.zervantDropSelect__menuContainer {
  position: absolute;
  width: inherit;
  z-index: 100;
  background: #FFF;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  border-radius: 2px;
}
.zervantDropSelect__menuEmptyMessage {
  font-size: 14px;
  padding: 16px 6px;
  padding-left: 8px;
  color: #697588;
  font-weight: 500;
}
.zervantDropSelect__menuItems {
  max-height: 280px;
  overflow-y: auto;
}
.zervantDropSelect__menuItem {
  font-size: 14px;
  padding: 8px 6px;
  padding-left: 8px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #002E33;
}
.zervantDropSelect__menuItem:hover {
  background: #F5F6F9;
}
.zervantDropSelect__menuItem__inactive {
  opacity: 0.4;
  cursor: no-drop;
}
.zervantDropSelect__menuAction {
  border-top: 1px solid #E8E9F0;
  font-weight: 600;
  color: #002E33;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 6px;
  padding-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.zervantDropSelect__clearIcon {
  height: 40px;
  position: absolute;
  width: 9px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
  cursor: pointer;
  left: 240px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/DropSelect/styles.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,kBAAA;AADF;AAGE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAII;EACE,yBAAA;EACA,0CAAA;UAAA,kCAAA;AAFN;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,oBAAA;AAJN;AAOI;EACE,oBAAA;AALN;AAOM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cCrCO;ADgCf;AAUE;EACE,6BAAA;MAAA,gBAAA;EACA,yDAAA;EACA,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;AARJ;AAWE;EACE,mBAAA;MAAA,oBAAA;UAAA,YAAA;AATJ;AAWI;EACE,YAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cCnES;AD0Df;AAWM;EACE,cClBC;ADST;AAQM;EACE,cClBC;ADST;AAQM;EACE,cClBC;ADST;AAQM;EACE,cClBC;ADST;AAQM;EACE,cClBC;ADST;AAYM;EACE,YAAA;AAVR;AAeE;EACE,6BAAA;MAAA,gBAAA;EACA,yDAAA;EACA,kCAAA;EACA,4BAAA;EACA,qBAAA;AAbJ;AAeI;EACE,eAAA;AAbN;AAiBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBCzFI;ED0FJ,wDAAA;UAAA,gDAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cCrDK;EDsDL,gBAAA;AAhBJ;AAmBE;EACE,iBAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cCzHW;ADuGf;AAoBI;EACE,mBCpEG;ADkDT;AAqBI;EACE,YAAA;EACA,eAAA;AAnBN;AAuBE;EACE,6BAAA;EACA,gBAAA;EACA,cCxIW;EDyIX,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArBJ;AAwBE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,oEAAA;EACA,eAAA;EACA,WAAA;AAtBJ","sourcesContent":["@import '../../../Global/Colors.scss';\n\n.zervantDropSelect {\n  width: 300px;\n  position: relative;\n\n  &__inputContainer {\n    width: inherit;\n    height: 40px;\n    border-radius: 2px;\n    display: flex;\n    border: 1px solid $Gray30;\n\n    &-active {\n      border: 1px solid $ElectricGreen;\n    }\n\n    &-highlight {\n      border: 1px solid $ElectricGreen;\n      box-shadow: 1px 1px 12px 0 $Gray20;\n    }\n\n    &-error {\n      border: 1px solid $Red;\n    }\n\n    &-disabled {\n      pointer-events: none;\n    }\n\n    &-emptyState {\n      pointer-events: none;\n\n      .zervantDropSelect__input {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        padding-left: 12px;\n        font-size: 12px;\n        color: $DeepSeaGreen;\n      }\n    }\n  }\n\n  &__searchIcon {\n    flex-basis: 24px;\n    background-image: url(./search.svg);\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n    background-position-x: 8px;\n    background-position-y: 13px;\n  }\n\n  &__input {\n    flex-grow: 1;\n\n    input {\n      height: 100%;\n      border: none;\n      box-sizing: border-box;\n      width: 100%;\n      font-family: 'Aeonik', sans-serif;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 2.29;\n      text-align: left;\n      padding-left: 8px;\n      padding-right: 24px;\n      color: $DeepSeaGreen;\n\n      &::placeholder {\n        color: $Gray60;\n      }\n\n      &:focus {\n        border: none;\n      }\n    }\n  }\n\n  &__dropIcon {\n    flex-basis: 40px;\n    background-image: url('~images/FilterButtonDropDown.svg');\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  &__menuContainer {\n    position: absolute;\n    width: inherit;\n    z-index: 100;\n    background: $White;\n    box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n    border-radius: 2px;\n  }\n\n  &__menuEmptyMessage {\n    font-size: 14px;\n    padding: 16px 6px;\n    padding-left: 8px;\n    color: $Gray90;\n    font-weight: 500;\n  }\n\n  &__menuItems {\n    max-height: 280px;\n    overflow-y: auto;\n  }\n\n  &__menuItem {\n    font-size: 14px;\n    padding: 8px 6px;\n    padding-left: 8px;\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: $DeepSeaGreen;\n\n    &:hover {\n      background: $Gray20;\n    }\n\n    &__inactive {\n      opacity: 0.4;\n      cursor: no-drop;\n    }\n  }\n\n  &__menuAction {\n    border-top: 1px solid $Gray30;\n    font-weight: 600;\n    color: $DeepSeaGreen;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 8px 6px;\n    padding-left: 8px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__clearIcon {\n    height: 40px;\n    position: absolute;\n    width: 9px;\n    background: url(./input-clear.svg) center no-repeat;\n    cursor: pointer;\n    left: 240px;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
